

import DataTable from 'datatables.net-dt';




function requestBanksDetails(dataTableParam) {
         var params = null;
        if (typeof dataTableParam == "undefined" || dataTableParam == null){
            var loanAmount;
            var installmentAmount;
            var loanWarranty = [];
            var loanDeposit;
            var loanBlock;
            var loanAmountSelector = '.js-inpval1-s1';
            var installmentAmountSelector = '.js-inpval2-s1';
            var loanWarrantySelector = '.js-wrntysPrnt-s1 .js-lblWrnty-s1.selected-t .js-wrntys-s1';

            loanAmount = $(loanAmountSelector).val().replace(/[, ]+/g, "").trim();
            installmentAmount = $(installmentAmountSelector).val().replace(/[, ]+/g, "").trim();

            $(loanWarrantySelector).each(function () {

                var item = $(this).val()
                loanWarranty.push(item);
            })

            loanDeposit = $('.js-tsitm1-s1 .js-inpItmPrnt1-s1.selected-t .js-inpItm1-s1').val()
            loanBlock = $('.js-tsitm2-s1 .js-inpItmPrnt2-s1.selected-t .js-inpItm2-s1').val()

            var parseLoanWarranty = loanWarranty.toString();

            params ={

                'loanAmount' : loanAmount,
                'installmentAmount' : installmentAmount,
                'loanWarranty' : parseLoanWarranty,
                'loanDeposit' : loanDeposit,
                'loanBlock' : loanBlock
            }
        }else {
            params ={
                'category_id' : dataTableParam.category_id
            }
        }

        var nmuConvertor = function(num){

            if (num != null && num != "" ){

                var parts = num.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return parts.join(".");
            } else {

                return "";
            }
        }


        $('#loan-table').DataTable( {

            "bPaginate": false,
            "bFilter": false,
            "bDestroy": true,
            "dom": '<"comesnttl-tpl-s1 mheading-tpl-t csgrn-m7 cslg-m7"i>',

            language: {

                "emptyTable": "هیچ داده‌ای در جدول وجود ندارد",
                "info": "" +
                    " <div class=\"csctn-s1 hinner-t\">\n" +
                    "     <h2 class=\"heading-t\">نتایج جستجو</h2>\n" +
                    "     <div class=\"csin-s1\">\n" +
                    "         <span class=\"csttl-s1\">_TOTAL_ مورد</span>\n" +
                    "     </div>\n" +
                    " </div>\n",
                "infoEmpty": "" +
                    " <div class=\"csctn-s1 hinner-t\">\n" +
                    "     <h2 class=\"heading-t\">نتایج جستجو</h2>\n" +
                    "     <div class=\"csin-s1\">\n" +
                    "         <span class=\"csttl-s1\">_TOTAL_ مورد</span>\n" +
                    "     </div>\n" +
                    " </div>\n",
                "infoFiltered": "" +
                    " <div class=\"csctn-s1 hinner-t\">\n" +
                    "     <h2 class=\"heading-t\">نتایج جستجو</h2>\n" +
                    "     <div class=\"csin-s1\">\n" +
                    "         <span class=\"csttl-s1\">_TOTAL_ مورد</span>\n" +
                    "     </div>\n" +
                    " </div>\n",
                "infoThousands": ",",
                "lengthMenu": "نمایش _MENU_ ردیف",
                "processing": "در حال پردازش...",
                "search": "جستجو:",
                "zeroRecords": "رکوردی با این مشخصات پیدا نشد",
                "paginate": {
                    "next": "بعدی",
                    "previous": "قبلی",
                    "first": "ابتدا",
                    "last": "انتها"
                },
                "aria": {
                    "sortAscending": ": فعال سازی نمایش به صورت صعودی",
                    "sortDescending": ": فعال سازی نمایش به صورت نزولی"
                },
                "autoFill": {
                    "cancel": "انصراف",
                    "fill": "پر کردن همه سلول ها با ساختار سیستم",
                    "fillHorizontal": "پر کردن سلول به صورت افقی",
                    "fillVertical": "پرکردن سلول به صورت عمودی"
                },
                "buttons": {
                    "collection": "مجموعه",
                    "colvis": "قابلیت نمایش ستون",
                    "colvisRestore": "بازنشانی قابلیت نمایش",
                    "copy": "کپی",
                    "copySuccess": {
                        "1": "یک ردیف داخل حافظه کپی شد",
                        "_": "%ds ردیف داخل حافظه کپی شد"
                    },
                    "copyTitle": "کپی در حافظه",
                    "pageLength": {
                        "-1": "نمایش همه ردیف‌ها",
                        "_": "نمایش %d ردیف",
                        "1": "نمایش 1 ردیف"
                    },
                    "print": "چاپ",
                    "copyKeys": "برای کپی داده جدول در حافظه سیستم کلید های ctrl یا ⌘ + C را فشار دهید",
                    "csv": "فایل CSV",
                    "pdf": "فایل PDF",
                    "renameState": "تغییر نام",
                    "updateState": "به روز رسانی",
                    "excel": "فایل اکسل",
                    "createState": "ایجاد وضعیت جدول",
                    "removeAllStates": "حذف همه وضعیت ها",
                    "removeState": "حذف",
                    "savedStates": "وضعیت های ذخیره شده",
                    "stateRestore": "بازگشت به وضعیت %d"
                },
                "searchBuilder": {
                    "add": "افزودن شرط",
                    "button": {
                        "0": "جستجو ساز",
                        "_": "جستجوساز (%d)"
                    },
                    "clearAll": "خالی کردن همه",
                    "condition": "شرط",
                    "conditions": {
                        "date": {
                            "after": "بعد از",
                            "before": "بعد از",
                            "between": "میان",
                            "empty": "خالی",
                            "not": "نباشد",
                            "notBetween": "میان نباشد",
                            "notEmpty": "خالی نباشد",
                            "equals": "برابر باشد با"
                        },
                        "number": {
                            "between": "میان",
                            "empty": "خالی",
                            "gt": "بزرگتر از",
                            "gte": "برابر یا بزرگتر از",
                            "lt": "کمتر از",
                            "lte": "برابر یا کمتر از",
                            "not": "نباشد",
                            "notBetween": "میان نباشد",
                            "notEmpty": "خالی نباشد",
                            "equals": "برابر باشد با"
                        },
                        "string": {
                            "contains": "حاوی",
                            "empty": "خالی",
                            "endsWith": "به پایان می رسد با",
                            "not": "نباشد",
                            "notEmpty": "خالی نباشد",
                            "startsWith": "شروع  شود با",
                            "notContains": "نباشد حاوی",
                            "notEndsWith": "پایان نیابد با",
                            "notStartsWith": "شروع نشود با",
                            "equals": "برابر باشد با"
                        },
                        "array": {
                            "empty": "خالی",
                            "contains": "حاوی",
                            "not": "نباشد",
                            "notEmpty": "خالی نباشد",
                            "without": "بدون",
                            "equals": "برابر باشد با"
                        }
                    },
                    "data": "اطلاعات",
                    "logicAnd": "و",
                    "logicOr": "یا",
                    "title": {
                        "0": "جستجو ساز",
                        "_": "جستجوساز (%d)"
                    },
                    "value": "مقدار",
                    "deleteTitle": "حذف شرط فیلتر",
                    "leftTitle": "شرط بیرونی",
                    "rightTitle": "شرط فرورفتگی"
                },
                "select": {
                    "cells": {
                        "1": "1 سلول انتخاب شد",
                        "_": "%d سلول انتخاب شد"
                    },
                    "columns": {
                        "1": "یک ستون انتخاب شد",
                        "_": "%d ستون انتخاب شد"
                    },
                    "rows": {
                        "1": "1ردیف انتخاب شد",
                        "_": "%d  انتخاب شد"
                    }
                },
                "thousands": ",",
                "searchPanes": {
                    "clearMessage": "همه را پاک کن",
                    "collapse": {
                        "0": "صفحه جستجو",
                        "_": "صفحه جستجو (٪ d)"
                    },
                    "count": "{total}",
                    "countFiltered": "{shown} ({total})",
                    "emptyPanes": "صفحه جستجو وجود ندارد",
                    "loadMessage": "در حال بارگیری صفحات جستجو ...",
                    "title": "فیلترهای فعال - %d",
                    "showMessage": "نمایش همه",
                    "collapseMessage": "بستن همه"
                },
                "loadingRecords": "در حال بارگذاری...",
                "datetime": {
                    "previous": "قبلی",
                    "next": "بعدی",
                    "hours": "ساعت",
                    "minutes": "دقیقه",
                    "seconds": "ثانیه",
                    "amPm": [
                        "صبح",
                        "عصر"
                    ],
                    "months": {
                        "0": "ژانویه",
                        "1": "فوریه",
                        "10": "نوامبر",
                        "4": "می",
                        "8": "سپتامبر",
                        "11": "دسامبر",
                        "3": "آوریل",
                        "9": "اکتبر",
                        "7": "اوت",
                        "2": "مارس",
                        "5": "ژوئن",
                        "6": "ژوئیه"
                    },
                    "unknown": "-",
                    "weekdays": [
                        "یکشنبه",
                        "دوشنبه",
                        "سه‌شنبه",
                        "چهارشنبه",
                        "پنجشنبه",
                        "جمعه",
                        "شنبه"
                    ]
                },
                "editor": {
                    "close": "بستن",
                    "create": {
                        "button": "جدید",
                        "title": "ثبت جدید",
                        "submit": "ایجــاد"
                    },
                    "edit": {
                        "button": "ویرایش",
                        "title": "ویرایش",
                        "submit": "به روز رسانی"
                    },
                    "remove": {
                        "button": "حذف",
                        "title": "حذف",
                        "submit": "حذف",
                        "confirm": {
                            "_": "آیا از حذف %d خط اطمینان دارید؟",
                            "1": "آیا از حذف یک خط اطمینان دارید؟"
                        }
                    },
                    "multi": {
                        "restore": "واگرد",
                        "noMulti": "این ورودی را می توان به صورت جداگانه ویرایش کرد، اما نه بخشی از یک گروه",
                        "title": "مقادیر متعدد",
                        "info": "مقادیر متعدد"
                    },
                    "error": {
                        "system": "خطایی رخ داده (اطلاعات بیشتر)"
                    }
                },
                "decimal": ".",
                "stateRestore": {
                    "creationModal": {
                        "button": "ایجاد",
                        "columns": {
                            "search": "جستجوی ستون",
                            "visible": "وضعیت نمایش ستون"
                        },
                        "name": "نام:",
                        "order": "مرتب سازی",
                        "paging": "صفحه بندی",
                        "search": "جستجو",
                        "select": "انتخاب",
                        "title": "ایجاد وضعیت جدید",
                        "toggleLabel": "شامل:",
                        "scroller": "موقعیت جدول (اسکرول)",
                        "searchBuilder": "صفحه جستجو"
                    },
                    "emptyError": "نام نمیتواند خالی باشد.",
                    "removeConfirm": "آیا از حذف %s مطمئنید؟",
                    "removeJoiner": "و",
                    "renameButton": "تغییر نام",
                    "renameLabel": "نام جدید برای $s :",
                    "duplicateError": "وضعیتی با این نام از پیش ذخیره شده.",
                    "emptyStates": "هیچ وضعیتی ذخیره نشده",
                    "removeError": "حذف با خطا موماجه شد",
                    "removeSubmit": "حذف وضعیت",
                    "removeTitle": "حذف وضعیت جدول",
                    "renameTitle": "تغییر نام وضعیت"
                }
            },
            ajax: {
                // url: 'https://investo.ir/v1/loan/index',
                url: '/v1/loan/index',
                dataSrc: 'rows',
                method: "POST",
                data:  params
            },
            columns: [
                {
                    data: 'title',
                    render: function (data) {

                        if(data.includes('بانک شهر')){
                            return '<div class="timgtx-m7 shahr-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک ملت')){
                            return '<div class="timgtx-m7 mellat-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک آینده')){
                            return '<div class="timgtx-m7 ayandeh-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک توسعه تعاون')){
                            return '<div class="timgtx-m7 taavon-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('سینا')){
                            return '<div class="timgtx-m7 sina-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک سپه')){
                            return '<div class="timgtx-m7 sepah-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک نور')){
                            return '<div class="timgtx-m7 nour-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک صادرات')){
                            return '<div class="timgtx-m7 saderat-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک رفاه')){
                            return '<div class="timgtx-m7 refah-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک تجارت')){
                            return '<div class="timgtx-m7 tejarat-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک مهر ایران')){
                            return '<div class="timgtx-m7 mehr-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک کارآفرین')){
                            return '<div class="timgtx-m7 karafarin-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک گردشگری')){
                            return '<div class="timgtx-m7 gardeshgari-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک کشاورزی')){
                            return '<div class="timgtx-m7 keshavarzi-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک پارسیان')){
                            return '<div class="timgtx-m7 parsian-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک مهراقتصاد')){
                            return '<div class="timgtx-m7 eghtesad-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک مهرا قتصاد')){
                            return '<div class="timgtx-m7 eghtesad-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک ملی')){
                            return '<div class="timgtx-m7 melli-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک مسکن')){
                            return '<div class="timgtx-m7 maskan-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک دی')){
                            return '<div class="timgtx-m7 day-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک پاسارگاد')){
                            return '<div class="timgtx-m7 pasargad-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک توسعه صادرات')){
                            return '<div class="timgtx-m7 toseesaderat-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک اقتصاد نوین')){
                            return '<div class="timgtx-m7 eghtesadnovin-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک اقتصادنوین')){
                            return '<div class="timgtx-m7 eghtesadnovin-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک حکمت ایرانیان')){
                            return '<div class="timgtx-m7 hekmatiranian-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک سرمایه')){
                            return '<div class="timgtx-m7 sarmayeh-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('بانک سامان')){
                            return '<div class="timgtx-m7 saman-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        if(data.includes('پست بانک')){
                            return '<div class="timgtx-m7 post-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                        else{
                            return '<div class="timgtx-m7 maskan-bank-s1"> <div class="timg-m7"></div> <span class="titx-m7">' + data + '</span> </div>';
                        }
                    }
                },
                { data: 'Interest' },
                {
                    data: 'need_deposit',
                    render: function (data) {

                        if (data === '1') {

                            return '<img class="tsttus-m7" src="/uploads/images/tick.svg" alt="SEO">';
                        } else {

                            return 'X';
                        }
                    }
                },
                {
                    data: 'max_time_to_pay_back',
                    className: 'tmonth-m7',
                    render: function (data) {

                        return '<span class="tnum-m7">' + data + '<span class="ntx-m7">ماه</span></span>';
                    }
                },
                { data: 'guarantor_type' },

                {
                    data: 'max_amount',
                    render: function (data) {

                        var commaData = nmuConvertor(data);

                        // var parts = data.toString().split(".");
                        // parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        // return parts.join(".");

                        return '<div class="prcunt-tpl-n5"> <div class="puctn-m7"> <span class="dgt-n5">' + commaData + '</span> </span> <span class="tx-n5">میلیون</span> </div>';
                    }
                },
                {
                    data: 'installment_amount',
                    render: function (data) {

                        var commaData = nmuConvertor(data);

                        return '<div class="prcunt-tpl-n5"> <div class="puctn-m7"> <span class="dgt-n5">' + commaData + '</span> </span> <span class="tx-n5">تومان</span> </div>';
                    }
                },
                {
                    data: 'opportunity_cost_of_blocking',
                    render: function (data) {

                        if (data == null) {

                            return '-';
                        }
                    }
                },
                {
                    data: 'total_interest_amount',
                    render: function (data) {

                        var commaData = nmuConvertor(data);

                        return '<div class="prcunt-tpl-n5"> <div class="puctn-m7"> <span class="dgt-n5">' + commaData + '</span> </span> <span class="tx-n5">تومان</span> </div>';
                    }
                },
                {
                    data: 'sum_amount_and_interest',
                    render: function (data) {

                        var commaData = nmuConvertor(data);

                        return '<div class="prcunt-tpl-n5"> <div class="puctn-m7"> <span class="dgt-n5">' + commaData + '</span> </span> <span class="tx-n5">تومان</span> </div>';
                    }
                },
            ]
        } );

        //This disable alert msg but it's very risky!
        $.fn.dataTable.ext.errMode = 'none';
}








export {requestBanksDetails};
